export class MemoryStorage implements Storage {
  // Internal data map
  private readonly _store = new Map<string, string>();

  /**
   * @inheritDoc
   */
  public get length() {
    return this._store.size;
  }

  /**
   * @inheritDoc
   */
  clear(): void {
    this._store.clear();
  }

  /**
   * @inheritDoc
   */
  getItem(key: string): string | null {
    return this._store.get(key) ?? null;
  }

  /**
   * @inheritDoc
   */
  key(index: number): string | null {
    return [...this._store.keys()][index] ?? null;
  }

  /**
   * @inheritDoc
   */
  removeItem(key: string): void {
    this._store.delete(key);
  }

  /**
   * @inheritDoc
   */
  setItem(key: string, value: string): void {
    this._store.set(key, value);
  }
}
